import React from 'react';

export default function Stats(props) {
  let count = props.count - 1;
  console.log(`testing count: ${count}`);

  const [avg, setAvg] = React.useState(0);
  const [highest, setHighest] = React.useState(0);

  React.useEffect(() => {
    try {
      //alert(localStorage.latest)
      //add latest to average and check highest
      if (localStorage.latest === undefined || localStorage.average === undefined || localStorage.highest === undefined || localStorage.index === undefined) {
        localStorage.latest = 0;
        localStorage.highest = 0;
        localStorage.index = 1;
        localStorage.average = 0;
      }
      else {
        if (localStorage.latest > 1) {
          localStorage.average = ((parseFloat(localStorage.average) * (parseInt(localStorage.index) - 1)) + parseInt(localStorage.latest)) / localStorage.index;
          localStorage.index = parseInt(localStorage.index) + 1;
          if (localStorage.latest > localStorage.highest) localStorage.highest = localStorage.latest;
          localStorage.latest = 0;
        }

        //main on load INIT
        setAvg(parseFloat(localStorage.average).toPrecision(2));
        setHighest(localStorage.highest);
      }

    }
    catch {
      console.log('LocalStorage error');
    }
  }, []);



  React.useEffect(() => {
    console.log(`testing count: ${count}`);
    if (count > 1) {
      localStorage.latest = count;
    }
  }, [count]);


  return (
    <div className='z-20 fixed flex group -right-48 hover:right-0 transition-all duration-500 shadow'>
      <div className='bg-white w-12 rounded-bl-lg text-90 bg-opacity-90'><p className='text-center flex items-center flex-col justify-center w-full h-full text-3xl'>=</p></div>
      <div className='flex flex-col bg-black bg-opacity-80 text-white p-4 rounded shadow w-48 '>
        <div className='flex'><figure>Average:</figure><p className='font-bold'>{avg}</p></div>
        <div className='flex'><figure>Highest:</figure><p className='font-bold'>{highest}</p></div>
      </div>
    </div>
  )
}